import React from 'react';
import { Route } from 'react-router-dom';

export default ({ code, children }) => ( // eslint-disable-line
    <Route
        render={({ staticContext }) => {
            if (staticContext) staticContext.status = code;
            return children;
        }}
    />
);
